import React, { useState } from "react";
import { ArrowRight, HelpCircle } from "lucide-react";
import { useLanguage } from "../i18n";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";

export const ProtocolsHelp = () => {
  const { t } = useLanguage();
  const s = t.smart;
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" data-testid="protocols-help-link" onClick={() => setOpen(true)} className="inline-flex items-center gap-1.5 text-xs text-amberdark hover:text-ink transition-colors">
        <ArrowRight className="w-3.5 h-3.5" strokeWidth={2} />{s.helpLink}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="protocols-help-dialog" className="bg-cream border-ink/10 rounded-sm max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl text-ink flex items-center gap-2"><HelpCircle className="w-5 h-5 text-amberdark" strokeWidth={1.5} />{s.helpTitle}</DialogTitle>
            <DialogDescription className="text-sm text-inksoft">{s.title}</DialogDescription>
          </DialogHeader>
          <div className="mt-2 space-y-3">
            {s.protocols.map((p, i) => (
              <div key={i} data-testid={`protocols-help-item-${i}`} className="bg-white border border-ink/10 rounded-sm p-4">
                <h4 className="font-display text-lg text-ink">{p.name}</h4>
                <p className="mt-1 text-sm leading-relaxed text-inksoft">{p.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-4 flex flex-wrap items-center justify-end gap-3">
            <button type="button" data-testid="protocols-help-close" onClick={() => setOpen(false)} className="bg-ink text-cream hover:bg-espresso rounded-sm px-5 h-10 text-xs font-semibold uppercase tracking-[0.15em]">{s.helpClose}</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
